@if (showParent) {
  @for (question of questions; track question) {
    <div class="form-group form-group--lg">
      @if (showLabel && (question?.question_prompt || question?.email_version)) {
        <label>
          {{question?.question_prompt ? question?.question_prompt : question?.email_version}}
        </label>
      }
      <app-question-radio-column
        (questionAnswer)="activateNextButton($event)"
        [useQuestionCopy]="true"
        [question]="question">
      </app-question-radio-column>
    </div>
  }
}

@if (!showParent) {
  @for (question of questions; track question) {
    <div class="form-group form-group--lg">
      @if (showLabel && (question?.question_prompt || question?.email_version)) {
        <label>
          {{question?.question_prompt ? question?.question_prompt : question?.email_version}}
        </label>
      }
      <app-question-radio-column
        (questionAnswer)="activateNextButton($event)"
        [useQuestionCopy]="true"
        [showLabel]="showParent"
        [question]="question">
      </app-question-radio-column>
    </div>
  }
}
